import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Autocomplete, TextField, Divider, Stack } from '@mui/material';
import useTranslation from '../../../hooks/useTranslation';
import FulfillmentCenterCard from './FulfillmentCenterCard';
import { useLogistics } from '../contexts/logisticsContext';

const AddFulfillmentCenters = ({ onFulfillmentCenterSelected, onRemoveFulfillmentCenterClicked, handleActivate, handleDeactivate, handleEdit }) => {
  const { t } = useTranslation();

  const { fulfillmentCenters, selectedFulfillmentCenter, setSelectedFulfillmentCenter, store } = useLogistics();

  const formatFulfillmentCenterList = (centers) => {
    if (centers.length === 0) return [];

    let existingFulfillmentCenterIds = store?.fulfillmentCenters?.map((center) => center.id) || [];
    return centers
      .filter((center) => !existingFulfillmentCenterIds.includes(center.id))
      .map((center) => ({ label: center.name, id: center.id }));
  };

  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Typography variant="subtitle1" fontWeight={600}>
          {t('labels.fulfillment_centers.add_fulfillment_centers_title')}
        </Typography>
        <Autocomplete
          fullWidth
          disablePortal
          options={formatFulfillmentCenterList(fulfillmentCenters)}
          inputValue={selectedFulfillmentCenter}
          onInputChange={(e, newValue, reason) => {
            if (reason === 'reset') setSelectedFulfillmentCenter('');
            else setSelectedFulfillmentCenter(newValue);
          }}
          onChange={(e, option) => option && onFulfillmentCenterSelected(option.id)}
          getOptionLabel={(option) => option.label || ''}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" size="small" label={t('labels.fulfillment_centers.fulfillment_centers_label')} />
          )}
        />
      </Stack>
      <Divider />
      <Grid container spacing={2}>
        {store?.fulfillmentCenters?.map((center) => (
          <Grid item xs={12} sm={6} key={center.id}>
            <FulfillmentCenterCard
              center={center}
              onRemove={onRemoveFulfillmentCenterClicked}
              onActivate={handleActivate}
              onDeactivate={handleDeactivate}
              onEdit={handleEdit}
            />
          </Grid>
        ))}
        {store?.fulfillmentCenters?.length === 0 && (
          <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
            <Typography variant="body2">{t('labels.fulfillment_centers.no_fulfillment_centers_text')}</Typography>
          </Grid>
        )}
      </Grid>
    </Stack>
  );
};

AddFulfillmentCenters.propTypes = {
  onFulfillmentCenterSelected: PropTypes.func.isRequired,
  onRemoveFulfillmentCenterClicked: PropTypes.func.isRequired,
  handleActivate: PropTypes.func.isRequired,
  handleDeactivate: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired
};

export default AddFulfillmentCenters;